import { h } from 'preact';
import { useTranslation } from '@/hooks/useTransition';
import { registerPatternDecoder } from './index';

const i18nSlotRegex = /^\{slot-i18n-(.+?)\}/;

// Define a small functional component that will use the translation hook
interface I18nTextRendererProps {
  i18nKey: string;
  i18nParams?: Record<string, string | number>;
  fallbackText?: string;
}

const I18nTextRenderer = ({ i18nKey, i18nParams, fallbackText }: I18nTextRendererProps) => {
  // Hook is called here, during component render
  const { t } = useTranslation();
  const translatedText = t(i18nKey, i18nParams);
  return <span style={{ width: 'auto', padding: '0 2px' }}>{translatedText || fallbackText}</span>;
};

registerPatternDecoder(i18nSlotRegex, (match: RegExpMatchArray, options: any) => {
  const i18nKey = match[1];

  if (!i18nKey) {
    console.warn('No i18n key extracted from slot pattern:', match[0]);
    // Fallback to options.text or an empty string if no key
    return <span>{options?.text ?? ''}</span>;
  }

  return (
    <I18nTextRenderer i18nKey={i18nKey} i18nParams={options?.i18nParams} fallbackText={`[${i18nKey}]`} />
  );
});
